import { client } from '../common/client';
import type { GetPageMetaResponse } from './utils/types';

export class PageAPIClient {
  public async getPageMeta(path: string): Promise<GetPageMetaResponse> {
    try {
      const response = await client.get(`/page/meta?path=${encodeURIComponent(path)}`);

      if (!response.ok) {
        const errorText = await response.text().catch(() => 'Unknown error');
        console.error(`[PageAPIClient] Error fetching meta: ${response.status} - ${errorText}`);
        throw new Error(`Failed to fetch page meta: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      return {
        title: 'SkinSeoul',
        description: 'Korean Beauty Products',
        type: 'website',
        url: `https://skinseoul.com${path}`,
      };
    }
  }
}

export const pageAPIClient = new PageAPIClient();
